/* Haus of Opulence — launch guard */
(function () {
  'use strict';

  function normalizeAddToCartLabels(root) {
    var scope = root || document;
    var candidates = scope.querySelectorAll ? scope.querySelectorAll('form[action*="/cart/add"] button, form[action*="/cart/add"] input[type="submit"], .product-form button, .product-form input[type="submit"]') : [];

    candidates.forEach(function (el) {
      var isInput = el.tagName === 'INPUT';
      var label = (isInput ? el.value : el.textContent || '').trim().toLowerCase().replace(/[-_]+/g, ' ').replace(/\s+/g, ' ');

      if (label === 'pre order' || label === 'preorder') {
        if (isInput) {
          el.value = 'Add to cart';
        } else {
          var textNode = Array.prototype.find.call(el.childNodes, function (node) {
            return node.nodeType === Node.TEXT_NODE && node.textContent.trim();
          });
          if (textNode) {
            textNode.textContent = 'Add to cart';
          } else {
            el.textContent = 'Add to cart';
          }
        }
        el.setAttribute('aria-label', 'Add to cart');
      }
    });
  }

  function correctFreeShippingMessage(root) {
    var scope = root || document;
    var messages = scope.querySelectorAll ? scope.querySelectorAll('.header-default .col-header.col-right') : [];

    messages.forEach(function (el) {
      var text = (el.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      if (text.indexOf('free shipping') !== -1 && (text.indexOf('no minimum') !== -1 || text.indexOf('$70') === -1)) {
        el.innerHTML = 'FREE SHIPPING* <br>$70 Minimum Purchase';
        el.setAttribute('aria-label', 'Free shipping on orders of $70 or more');
      }
    });
  }

  function run() {
    normalizeAddToCartLabels(document);
    correctFreeShippingMessage(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === Node.ELEMENT_NODE) {
          normalizeAddToCartLabels(node);
          correctFreeShippingMessage(node);
        }
      });
    });
    normalizeAddToCartLabels(document);
    correctFreeShippingMessage(document);
  });

  observer.observe(document.documentElement, { childList: true, subtree: true, characterData: true });
})();
